import { render, staticRenderFns } from "./EpayRedirect.vue?vue&type=template&id=472c6e20"
import script from "./EpayRedirect.vue?vue&type=script&lang=js"
export * from "./EpayRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports